import { render, staticRenderFns } from "./ServicesPage.vue?vue&type=template&id=3ec8a387&scoped=true"
import script from "./ServicesPage.vue?vue&type=script&lang=js"
export * from "./ServicesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec8a387",
  null
  
)

export default component.exports